import { IBetPositionByService } from '../../types/reducers/betPosition';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const LOAD_BET_POSITION_SUCCESS = 'BET_POSITION :: LOAD_BET_POSITION_SUCCESS';

export type TLoadBetPositionSuccessAction = IReduxAction<typeof LOAD_BET_POSITION_SUCCESS, IBetPositionByService>;

export const loadBetPositionSuccess = actionGenerator<typeof LOAD_BET_POSITION_SUCCESS, IBetPositionByService>(
  LOAD_BET_POSITION_SUCCESS,
);
